import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { withStyles } from '@material-ui/core/styles'

import * as searchHelper from '../../util/searchHelper'
import { filterProposals } from '../../redux/actions/proposalsActions'
import { useTranslation } from 'react-i18next'

const styles = theme => ({
  root: {
    color: theme.modeColors.checkbox
  },
  label: {
    fontFamily: 'HarmoniaSansStd',
    paddingTop: 4,
    color: theme.modeColors.checkboxLabel,
    fontSize: 14
  }
})

const Shortlisted = ({ filterProposals, history, classes }) => {
  const [checkedF, setCheckedF] = React.useState(false)
  const { t } = useTranslation('navbar')

  React.useEffect(() => {
    const { search } = history.location
    const searchQuery = searchHelper.getSearchQuery(search)

    if (searchQuery.shortlisted) {
      setCheckedF(!!searchQuery.shortlisted)
    }
  }, [history.location])

  const handleChange = event => {
    setCheckedF(event.target.checked)

    history.replace({
      search: searchHelper.updateSearchQuery(
        history.location.search,
        'shortlisted',
        event.target.checked
      )
    })

    filterProposals(history.location.search)
  }

  return (
    <FormControlLabel
      id="filter-shortlisted-proposals"
      control={
        <Checkbox
          className={classes.root}
          checked={checkedF}
          onChange={handleChange}
          value="checkedF"
          color="default"
        />
      }
      label={t('Shortlisted by Jury')}
      classes={{
        label: classes.label
      }}
    />
  )
}

export default withRouter(
  connect(null, { filterProposals })(withStyles(styles)(Shortlisted))
)
